import React from 'react';
import { artistFields } from '../artistProfile';

export default function ArtistProfileSummary({ profile = {} }) {
  const { artCategories } = artistFields(profile);
  const location = profile.locationLabel || [profile.area, profile.city, profile.country].filter(Boolean).join(', ');
  return <div className="artist-summary">
    {location && <p className="artist-location">{location}</p>}
    <div className="artist-tags">{artCategories.map((category) => <span key={category}>{category}</span>)}</div>
  </div>;
}
